import TableNew from '../common/tableNew';
import PlanPoints from '../plan/planPoints';

import { elssComparisonTable } from '../../constants';
export const ELSS = () => {
  return (
    <div className="sm:lil-w-full">
      <PlanPoints />
      <div className="lil-mb-12">
        <TableNew data={elssComparisonTable} />
        <div className="mt10">*Taxable @ 10% over and above Rs 1 lakh.</div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./components/singleFundNewCmp/eLSS.tsx